<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Créditos</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
              <li class="breadcrumb-item active">Créditos</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-agregar-credito" class="info-box mb-3" @click="nuevoCredito" data-toggle="modal"
            data-target="#creditoModal">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-info elevation-1"><i
                class="fas fa-plus"></i></a>
            <div class="info-box-content">
              <span class="info-box-text">Credito</span>
              <span class="info-box-number">Agregar</span>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-descargar-pdf" class="info-box mb-3" @click="descargarPDF()" style="cursor: pointer;">
            <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-danger elevation-1">
              <i class="fas fa-file-pdf"></i>
            </a>
            <div class="info-box-content">
              <span class="info-box-text">Reporte</span>
              <span class="info-box-number">Descargar PDF</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Lista de créditos</h3>
            </div>
            <div class="card-body">
              <table id="tablaCreditos" class="table table-hover align-middle border-bottom">
  <thead class="table-light text-secondary border-bottom">
    <tr>
      <th>Cliente</th>
      <th style="width: 20%;">Límite y Disponible</th>
      <th style="width: 25%;">Resumen de Deuda</th>
      <th style="width: 12%;" class="text-center">Vencimiento</th>
      <th style="width: 12%;" class="text-center">Estatus</th>
      <th style="width: 50px;" class="text-center"></th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(credito, index) in creditos" :key="credito.id">
      <!-- Cliente -->
      <td>
        <a 
          href="javascript:void(0)" 
          @click="irAlHistorial(credito.cliente_id)"
          class="fw-semibold text-dark text-decoration-none"
        >
          {{ credito.cliente.nombre }}
        </a>
        <small class="text-muted d-block" v-if="credito.cliente.rif">{{ credito.cliente.rif }}</small>
      </td>

      <!-- COLUMNA 1: Límite y Disponible -->
      <td>
        <div class="d-flex flex-column gap-1">
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted small">Límite:</span>
            <span class="fw-semibold text-dark">${{ (+credito.limite).toFixed(2) }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted small">Disponible:</span>
            <span 
              class="fw-semibold" 
              :class="(credito.limite - (credito.deuda - credito.abonado)) > 0 ? 'text-success' : 'text-danger'"
            >
              ${{ (credito.limite - (credito.deuda - credito.abonado)).toFixed(2) }}
            </span>
          </div>
        </div>
      </td>

      <!-- COLUMNA 2: Consumo, Abonado y Compromiso Restante -->
      <td>
        <div class="d-flex flex-column gap-1">
          <!-- Consumo / Deuda Total -->
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted small">Consumo:</span>
            <span class="text-dark fw-medium">${{ (+credito.deuda).toFixed(2) }}</span>
          </div>

          <!-- Abonado -->
          <div class="d-flex justify-content-between align-items-center">
            <span class="text-muted small">Abonado:</span>
            <span class="text-success fw-medium">${{ (+credito.abonado).toFixed(2) }}</span>
          </div>

          <!-- Compromiso Restante -->
          <div class="d-flex justify-content-between align-items-center border-top pt-1 mt-1">
            <span class="text-muted small fw-semibold">Compromiso:</span>
            <span 
              :class="(credito.deuda - credito.abonado) > 0 ? 'text-danger fw-bold' : 'text-muted fw-semibold'"
            >
              ${{ (credito.deuda - credito.abonado).toFixed(2) }}
            </span>
          </div>
        </div>
      </td>

      <!-- Vencimiento -->
      <td class="text-center text-nowrap text-muted">
        <small>{{ credito.fecha_vencimiento || 'Indefinido' }}</small>
      </td>

      <!-- Estatus -->
      <td class="text-center">
        <span 
          class="badge rounded-pill fw-medium text-capitalize px-2 py-1"
          :class="[
            credito.estatus === 'activo' ? 'bg-success-subtle text-success border border-success-subtle' :
            credito.estatus === 'bloqueado' ? 'bg-danger-subtle text-danger border border-danger-subtle' :
            'bg-warning-subtle text-warning-emphasis border border-warning-subtle'
          ]"
        >
          {{ credito.estatus }}
        </span>
      </td>

      <!-- Acciones (Menú desplegable minimalista) -->
      <td class="text-center">
        <div class="dropdown">
          <button 
            type="button" 
            class="btn btn-link text-muted p-1 text-decoration-none" 
            data-bs-toggle="dropdown" 
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fas fa-ellipsis-v"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end shadow-sm border-0">
            <a 
              href="javascript:void(0)" 
              class="dropdown-item btn-historial" 
              :data-id="credito.cliente_id"
              @click="irAlHistorial(credito.cliente_id)"
            >
              <i class="fas fa-folder-open text-muted me-2"></i> Ver Historial
            </a>
            <a 
              href="javascript:void(0)" 
              class="dropdown-item btn-ver-mas" 
              :data-index="index" 
              data-toggle="modal" 
              data-target="#creditoModal"
              data-bs-toggle="modal"
              data-bs-target="#creditoModal"
            >
              <i class="fas fa-info-circle text-info me-2"></i> Ver Detalles
            </a>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <credito-modal v-if="modalActivo" ref="creditoModal" :creditData="editingCredit" @saved="actualizar"
      @cancelled="actualizar" />
  </section>
</template>

<script>
import { nextTick, getCurrentInstance } from "vue";
import api from "@/services/api";
import CreditoModal from "./CreditoModal.vue";
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';
import { tutorial } from "@/plugins/tutorial";


export default {
  components: { CreditoModal },
  data() {
    return {
      creditos: [],
      editingCredit: null,
      modalActivo: false,
    };
  },
  setup() {
    const { proxy } = getCurrentInstance();
    return { proxy };
  },
  methods: {
    irAlHistorial(clienteId) {
      this.$router.push({
        name: 'historial',
        params: { id: clienteId }
      });
    },
    async obtenerCreditos() {
      try {
        const respuesta = await api.get('/credito');
        this.creditos = respuesta.data;
        // Esperamos que Vue pinte el <tbody>
        await nextTick();

        // Solo inicializamos DataTable la primera vez
        if (!this.dt && window.$ && $.fn.DataTable) {
          this.dt = $("#tablaCreditos").DataTable({
            responsive: true,
            autoWidth: false,
            columnDefs: [
              { responsivePriority: -1, targets: 0 },
              { responsivePriority: 1, targets: 2 },
              { responsivePriority: -1, targets: 5 },
            ],
            pageLength: 10,
            lengthChange: false,
            pagingType: "numbers",
            language: {
              url:
                "https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json"
            },
            // Estructura de DOM con filtro, tabla, info y paginación centrados
            dom:
              '<"row mb-3"<"col-12 col-md-6"f>>' +
              "t" +
              '<"row mt-3"<"col-12 text-center"i>>' +
              '<"row"<"col-12 d-flex justify-content-center"p>>'
          });
        }
        // Escuchar clicks en el botón Historial
        $("#tablaCreditos").on("click", ".btn-historial", (e) => {
          const id = $(e.currentTarget).data("id");
          this.irAlHistorial(id);
        });

        // Escuchar clicks en el botón Ver más
        $("#tablaCreditos").on("click", ".btn-ver-mas", (e) => {
          const index = $(e.currentTarget).data("index");
          this.verMas(this.creditos[index]);
        });
      } catch (error) {
        console.error('Error al obtener los créditos:', error);
      }
    },
    async descargarPDF() {
      try {
        loading.show('Generando PDF...');
        const response = await api.get("/pdf/creditos", { responseType: 'blob' });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Reporte_Creditos.pdf');
        document.body.appendChild(link);
        link.click();
        loading.hide();
      } catch (error) {
        loading.hide();
        alert.show({ title: 'Error', text: 'No se pudo generar el PDF', icon: 'error' });
      }
    },
    verMas(credito) {
      this.editingCredit = credito;
      this.modalActivo = true;
    },
    nuevoCredito() {
      this.modalActivo = true;
    },
    actualizar() {
      this.obtenerCreditos()
      this.editingCredit = ''
    },
    recalcularTabla() {
      if (this.dt) {
        this.dt.columns.adjust().responsive.recalc();
      }
    },
    iniciarTutorial() {
      const steps = [
        {
          element: '#btn-agregar-credito',
          title: 'Nuevo Crédito',
          text: 'Haz clic aquí para registrar un nuevo crédito a un cliente.',
          position: 'bottom'
        },
        {
          element: '#btn-descargar-pdf',
          title: 'Descargar Reporte',
          text: 'Haz clic aquí para generar un PDF con el listado de créditos.',
          position: 'bottom'
        },
        {
          element: '.card-body',
          title: 'Listado de Créditos',
          text: 'Aquí verás la lista de créditos y su estado actual.',
          position: 'top'
        }
      ];

      const table = window.$('#tablaCreditos');
      const isCollapsed = table.hasClass('collapsed');
      const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

      if (isCollapsed && !actionsVisible) {
        const firstRow = table.find('tbody tr:first-child');
        if (firstRow.hasClass('parent')) {
          const control = firstRow.find('.dtr-control');
          if (control.length) control.click();
          else firstRow.find('td:first-child').click();
        }

        steps.push({
          element: '#tablaCreditos tbody tr:first-child td:first-child',
          title: 'Ver Detalles',
          text: 'En pantallas pequeñas, haz clic en el símbolo (+) para ver los datos ocultos.',
          position: 'bottom',
          tooltipClass: 'hide-next-btn'
        });

        firstRow.off('click.tutorial');
        firstRow.on('click.tutorial', function () {
          setTimeout(() => {
            const tooltip = document.querySelector('.introjs-tooltip');
            if (!tooltip) return;
            if (window.$(this).hasClass('parent')) {
              tooltip.classList.remove('hide-next-btn');
            } else {
              tooltip.classList.add('hide-next-btn');
            }
          }, 200);
        });

        steps.push({
          element: '.dtr-details .btn-secondary',
          title: 'Ver más',
          text: 'Haz clic aquí para ver el detalle completo o gestionar abonos.',
          position: 'left'
        });
      } else {
        steps.push({
          element: '.btn-secondary',
          title: 'Ver más',
          text: 'Haz clic aquí para ver el detalle completo o gestionar abonos.',
          position: 'left'
        });
      }

      tutorial.start(steps);
    }
  },
  mounted() {
    this.obtenerCreditos();
    window.addEventListener('resize', this.recalcularTabla);
    tutorial.set(this.iniciarTutorial);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.recalcularTabla);
    if (this.dt) {
      this.dt.destroy();
      this.dt = null;
    }
    tutorial.set(null);
  },
};
</script>
<style>
.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
  display: none !important;
}
</style>